import { NavbarBrand } from '@heroui/react';

import IsoLogoWhite from '@/shared/assets/isotipo-cft-maule-white.png';

/**
 * Componente que renderiza el logo institucional del CFT Región del Maule
 * Muestra el isotipo en blanco con texto descriptivo en desktop
 * El texto se oculta en dispositivos móviles
 */
const NavbarLogo = () => {
  return (
    <NavbarBrand>
      <div className="flex items-center w-10 md:w-12 h-auto gap-6">
        <img
          src={IsoLogoWhite}
          alt="Logo isotipo color blanco del CFT Estatal del Maule"
        />

        <p className="font-bold text-secondary-white text-2xl hidden md:flex">
          CFT Región del Maule
        </p>
      </div>
    </NavbarBrand>
  );
};

export default NavbarLogo;
